import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import PersonaFi from "@/pages/PersonaFi";

export const Route = createFileRoute("/pl/personaFi")({
  head: () => routeHead('AGAPE PersonaFi — Walidacja person z AI', META_DESCRIPTIONS.personafi.pl, '/pl/personaFi'),
  component: PersonaFi,
});
